var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g3, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 133,
    viewBox: "0 0 194 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1316_1876",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 74,
    width: 45,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.668 74.9697H97.131V132.344H53.668V74.9697Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1316_1876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9322 75.0039L53.8516 116.297L96.7371 132.338L96.8387 79.7817L71.9322 75.0039Z",
    fill: "#7CB22F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3876 78.7616L0.392642 128.679C-0.583245 129.692 0.40601 131.346 1.76156 130.965L53.8472 116.301L71.9292 75.0078L48.3876 78.7616Z",
    fill: "#6EA52C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.32 126.771L145.959 78.7616L121.055 75.0078L141.524 116.303L191.998 129.08C193.352 129.422 194.301 127.767 193.32 126.771Z",
    fill: "#7CB22F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1316_1876",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 74,
    width: 46,
    height: 59
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4434 74.9697H141.618V132.344H96.4434V74.9697Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1316_1876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8366 79.7856L96.7363 132.342L141.531 116.303L121.061 75.0078L96.8366 79.7856Z",
    fill: "#6EA52C"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8037 93.9325L37.0442 90.5624L67.3716 85.4209L66.2633 87.9488L33.8037 93.9325Z",
    fill: "#DDDCDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2969 98.4665L96.1699 95.9546L125.019 82.998L126.242 85.4658L97.2969 98.4665Z",
    fill: "#DDDCDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6287 100.804L17.0921 111.307L13.5107 115.03L42.0401 107.775L32.1074 122.42L36.2315 121.243L46.0586 106.753L59.5245 103.328L60.6287 100.804Z",
    fill: "#DDDCDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.982 108.179L150.284 103.259L139.906 87.6088L157.394 90.352L154.414 87.328L125.02 82.998L126.243 85.4658L136.22 87.0313L146.48 102.501L133.396 99.8956L134.819 102.764L178.429 111.672L174.982 108.179Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.82 102.765L133.398 99.8965L96.7715 114.697V117.66L114.483 110.726L118.925 124.355L121.543 123.502L117.05 109.721L134.82 102.765Z",
    fill: "#DDDCDB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9289 91.7013L96.2755 98.5085L97.1886 95.9124L67.3692 85.4209L66.2623 87.9488L74.3328 90.7883L69.6298 104.264L60.6329 100.805L59.5273 103.329L96.7675 117.66V114.696L72.1992 105.251L76.9289 91.7013Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1316_1876",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 0,
    width: 80,
    height: 104
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0938 0H136.491V103.718H57.0938V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1316_1876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.36 39.5258C136.36 63.2225 102.292 103.674 96.8416 103.674C92.1667 103.674 57.3262 65.5994 57.3262 39.5258C57.3262 17.6954 75.0191 -0.00292969 96.8429 -0.00292969C118.668 -0.00292969 136.36 17.6954 136.36 39.5258Z",
    fill: "#E33824"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.095 39.528C121.095 52.9311 110.232 63.7982 96.8319 63.7982C83.4315 63.7982 72.5684 52.9311 72.5684 39.528C72.5684 26.1236 83.4315 15.2578 96.8319 15.2578C110.232 15.2578 121.095 26.1236 121.095 39.528Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6cc93be6abe08c9635408c4b6ce04684.svg";
export { ForwardRef as ReactComponent };